module.exports = __webpack_public_path__ + "img/zudongq3.88a40ecd.png";